<template>
  <div class="big-images">
    <a-modal
      :visible="previewVisible"
      :width="1000"
      :footer="null"
      @cancel="closeBig"
    >
      <img alt="img" style="width: 100%" :src="url" />
    </a-modal>
    <img
      alt="img"
      class="defaultImg"
      :src="url ? url : require('@/assets/images/face.png')"
      @click="hanldeImg"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      confirmLoading: false,
      previewVisible: false,
      previewImage: this.url || "",
    };
  },
  methods: {
    closeBig() {
      this.previewVisible = false;
    },
    hanldeImg() {
      if (!this.url) return;
      this.previewVisible = true;
    },
    back(data) {
      this.$emit("uploadOk", data);
    },
  },
};
</script>
<style lang="less">
.big-images {
  border: 1px solid #dedede;
  width: 30px;
  cursor: pointer;
  .defaultImg {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
  .defaultImg:hover {
    opacity: 0.8;
  }
}
</style>
